"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["title", "className", "content", "titleElement"],
    _excluded2 = ["title", "className", "content"],
    _excluded3 = ["className", "detailed", "divided", "inline", "isDark", "items", "middot", "stretch", "split", "stepped", "ticked"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var generateItems = function generateItems(_ref) {
  var items = _ref.items,
      ticked = _ref.ticked,
      inline = _ref.inline,
      middot = _ref.middot,
      stepped = _ref.stepped;
  return items.map(function (item, i) {
    var body;
    var title;
    var className;
    var content;
    var TitleComponent = "h3";
    var liProps;

    if ( /*#__PURE__*/_react.default.isValidElement(item) || typeof item === "string" || typeof item === "number") {
      content = item;
    } else if (item && _typeof(item) === "object" && "content" in item) {
      if ("titleElement" in item) {
        var _item = item;
        title = _item.title;
        className = _item.className;
        content = _item.content;
        var _item$titleElement = _item.titleElement;
        TitleComponent = _item$titleElement === void 0 ? "h3" : _item$titleElement;
        liProps = _objectWithoutProperties(_item, _excluded);
        _item;
      } else {
        var _item2 = item;
        title = _item2.title;
        className = _item2.className;
        content = _item2.content;
        liProps = _objectWithoutProperties(_item2, _excluded2);
        _item2;
      }
    }

    if (stepped) {
      body = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TitleComponent, {
        className: "p-stepped-list__title"
      }, title), /*#__PURE__*/_react.default.createElement("p", {
        className: "p-stepped-list__content"
      }, content));
    } else {
      body = content;
    }

    return /*#__PURE__*/_react.default.createElement("li", _extends({
      className: (0, _classnames.default)(className, {
        "p-list__item": !inline && !stepped,
        "p-inline-list__item": inline,
        "p-stepped-list__item": stepped,
        "is-ticked": ticked
      }),
      key: i
    }, liProps), body, middot ? " " : null);
  });
};

var List = function List(_ref2) {
  var className = _ref2.className,
      detailed = _ref2.detailed,
      divided = _ref2.divided,
      inline = _ref2.inline,
      isDark = _ref2.isDark,
      items = _ref2.items,
      middot = _ref2.middot,
      stretch = _ref2.stretch,
      split = _ref2.split,
      stepped = _ref2.stepped,
      ticked = _ref2.ticked,
      props = _objectWithoutProperties(_ref2, _excluded3);

  var Component = stepped ? "ol" : "ul";
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: (0, _classnames.default)(className, {
      "p-list": !divided && !inline && !middot && !stretch && !stepped,
      "p-list--divided": divided,
      "p-inline-list": inline,
      "p-inline-list--middot": middot,
      "p-inline-list--stretch": stretch,
      "p-stepped-list": stepped && !detailed,
      "p-stepped-list--detailed": stepped && detailed,
      "is-dark": isDark,
      "is-split": split
    })
  }, props), generateItems({
    items: items,
    ticked: ticked,
    inline: inline || middot || stretch,
    middot: middot,
    stepped: stepped
  }));
};

var _default = List;
exports.default = _default;